import { observable, action } from 'mobx'

class ExploreStore {

  @observable isShowingCategories = false

  @action.bound toggle() {
    this.isShowingCategories = !this.isShowingCategories
  }

  @action.bound expand() {
    this.isShowingCategories = true
  }

  @action.bound collapse() {
    this.isShowingCategories = false
  }
}

export default new ExploreStore()



// WEBPACK FOOTER //
// ./src/stores/exploreStore.js